export default __webpack_public_path__ + "static/media/beebeauty.d78abd6a.png";